var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdFilmFilled = function SvgAdFilmFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24951 10.624C2.24951 10.0717 2.69723 9.62402 3.24951 9.62402H11.6574V19.9952H3.24951C2.69723 19.9952 2.24951 19.5475 2.24951 18.9952V10.624Z",
    fill: "#F1F8FF",
    stroke: "#2698EB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45361 19.9951H9.12568L9.68093 29.3068C9.7152 29.8815 9.25839 30.3663 8.6827 30.3663H7.01419C6.48502 30.3663 6.04746 29.9541 6.01596 29.4258L5.45361 19.9951Z",
    fill: "#F1F8FF",
    stroke: "#2698EB",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4886 3.00757C29.1445 2.75051 29.8535 3.23414 29.8535 3.93862L29.8535 24.0186C29.8535 24.6861 29.212 25.1662 28.5715 24.978L11.6686 20.0096L11.6686 9.59953L28.4886 3.00757Z",
    fill: "#F1F8FF",
    stroke: "#2698EB",
    strokeWidth: 2
  })));
};
export default SvgAdFilmFilled;